export default "__VITE_ASSET__CfsYhvaS__"